var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.preloader)?_c('div',{staticClass:"preloader"},[_c('lottie',{staticClass:"anim",attrs:{"options":_vm.loading,"height":_vm.getScreen ? 200 : 500,"width":_vm.getScreen ? 200 : 500}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }